import clientsSlice from "./clientsSlice";
import languageSlice from "./languageSlice";
import sitesSlice from "./sitesSlice";
import mySitesSlice from "./mySitesSlice";
import snackbarSlice from "./snackbarSlice";

export const languageReducers = {
  languageSlice,
};

export const sitesReducers = {
  sitesSlice,
  mySitesSlice,
};

export const clientsReducers = {
  clientsSlice,
};

export const snackbarReducers = { snackbarSlice };
